(function(angular){
	'use strict';
	
	var capitalStackObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			elements: '<',
			total: '<'
		},
		controller: [CapitalStackFunction],
		controllerAs: 'capitalStack'
	};
	
	angular
		.module('viewReitElementModule')
		.component('capitalStack', capitalStackObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/reit/capital-stack.html';
	}
	
	function CapitalStackFunction(){
		var capitalStack = this;

		function populatePercentOfTotal() {
			if(angular.isDefined(capitalStack.elements)) {
				angular.forEach(capitalStack.elements, function(element) {
					element.styleObj = { height: (element.percentOfTotal * 100) + '%'};
				});
			}
		}

		capitalStack.$onInit = function() {
			populatePercentOfTotal();
		};

		capitalStack.$onChanges = function(changesObj) {
			populatePercentOfTotal();
		};
	}
})(window.angular);